import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'
import logo from '../../assets/logo_white.svg'
import location from '../../assets/icons/location-white.png'
import call from '../../assets/icons/phone-white.png'
import mail from '../../assets/icons/mail-white.png'
//import facebook from '../../assets/icons/facebook-white.svg'
import instagram from '../../assets/icons/instagram-white.svg'
import linkedin from '../../assets/icons/linkedin-white.svg'
import whatsapp from '../../assets/icons/whatsapp-white.svg'
import footer_bg from '../../assets/footer-bg.jpg'

export default function Footer() {

    const year = new Date().getFullYear();

    return (
        <footer>
            <div className="footer-bg">
                <img src={footer_bg} alt="Footer Background" />
            </div>
            <div className="footer">
                <div className="footer_logo">
                    <Link to="/">
                        <img src={logo} alt="Academic Outreach and New Initiatives | IIT Delhi" />
                    </Link>
                </div>
                <div className="footer_navs">
                    {/* <div className="footer_links">
                        <h4>Navigation</h4>
                        <Link to="/">Home</Link>
                        <Link to="/events">Events</Link>
                        <Link to="/programs">Programs</Link>
                        <Link to="/international">International</Link>
                        <Link to="/releases">Releases</Link>
                        <Link to="/about">About Us</Link>
                    </div> */}
                    <div className="footer_links">
                        <h4>Useful Links</h4>
                        <Link target='_blank' to="https://home.iitd.ac.in/about.php">About the Institute</Link>
                        <Link target='_blank' to="https://home.iitd.ac.in/administration.php">Administration</Link>
                        <Link target='_blank' to="https://timetable.iitd.ac.in/calendar">Academic Calendar</Link>
                        <Link target='_blank' to="https://home.iitd.ac.in/ug-admissions.php">UG Admissions</Link>
                        <Link target='_blank' to="https://home.iitd.ac.in/pg-admissions.php">PhD/PG Admissions</Link>
                    </div>
                    <div className="footer_links">
                        <h4>Contact Us</h4>
                        <div className="contact_link">
                            <img src={location} alt="Location" />
                            <p>
                                Office of the Dean Academics<br />
                                Lecture Hall Complex, Room LH301<br />
                                Indian Institute of Technology Delhi<br />
                                Hauz Khas<br />
                                New Delhi - 110016, India
                            </p>
                        </div>
                        <div className="contact_link">
                            <img src={call} alt="Call" />
                            <p><Link to="tel:+911126597367">+91-11-2659-7367</Link></p>
                        </div>
                        <div className="contact_link">
                            <a href="mailto:adoni@iitd.ac.in" className='email_link'>
                                <img src={mail} alt="Email" />
                                <p>adoni@iitd.ac.in</p>
                            </a>
                        </div>
                        <div className="contact_link">
                            <a href="mailto:acadoutreach@iitd.ac.in" className='email_link'>
                                <img src={mail} alt="Email" />
                                <p>acadoutreach@iitd.ac.in</p>
                            </a>
                        </div>

                        {/* <div className="contact_link">
                            <img src={call} alt="Call" />
                            <p>Abu Dhabi: <Link to="tel:+971 (0) 50 355 9173">+971 (0) 50 355 9173</Link></p>
                        </div> */}
                        <div className="footer_social">
                            {/*
                            <Link to="https://www.facebook.com/AcademicOutreachIITDelhi" target="_blank" rel="noreferrer">
                                <img src={facebook} alt="Facebook" />
                            </Link>
                            */}
                            <Link to="https://www.instagram.com/outreach_iitd/" target="_blank" rel="noreferrer">
                                <img src={instagram} alt="Instagram" />
                            </Link>
                            <Link to="https://whatsapp.com/channel/0029Vb994QoLtOjByAcUQW3n" target="_blank" rel="noreferrer">
                                <img src={whatsapp} alt="WhatsApp" />
                            </Link>
                            <Link to="https://in.linkedin.com/company/academic-outreach-iitd/" target="_blank" rel="noreferrer">
                                <img src={linkedin} alt="LinkedIn" />
                            </Link>
                        </div>
                    </div>

                </div>
            </div>
            <div className="footer_bar">
                <p>© Copyright {year} : <span>Academic Outreach and New Initiatives, IIT Delhi</span></p>
            </div>
        </footer>
    )
}
